import { includesOneOfErrorMessages, UserRole } from '@shared/utils'

export function checkMessagingAvailability(user) {
  if (!user) return [false]
  if (user.role === UserRole.Patient) {
    if (!user.enrolled) return [false, 'Patient is not enrolled']
    if (user.disabled) return [false, 'Patient is disabled']
  }
  return [true]
}

export const isOutOfOfficeError = (error) => includesOneOfErrorMessages(error, ['Recipient is out of office'])

export const outOfOfficeBlockedMessage =
  'Your message was not sent. One or more recipients are currently Out of Office and cannot receive internal messages.'
